import { useMemo } from "react";
import { getEnvironmentVariable } from "../global/environmentVariables";

const SUPPORTED_EMBEDDED_ENVIRONMENTS = {
  // Add new embedded environments as we want here
  "warhammer-dev": {
    brandName: "Warhammer",
    storagePrefix: "warhammer",
  },
  "warhammer-prod": {
    brandName: "Warhammer",
    storagePrefix: "warhammer",
  },
  "warmachine-dev": {
    brandName: "Warmachine",
    storagePrefix: "warmachine",
  },
  "warmachine-prod": {
    brandName: "Warmachine",
    storagePrefix: "warmachine",
  },
};

export function useEmbeddedEnvironment() {
  const AMPLIFY_BRANCH = getEnvironmentVariable("AMPLIFY_BRANCH");

  return useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const isEmbedded = urlParams.get("embed") === "true";

    const environmentConfig = SUPPORTED_EMBEDDED_ENVIRONMENTS[AMPLIFY_BRANCH];
    const isSupported = Boolean(environmentConfig);

    return {
      isEmbeddedEnvironment: isSupported && isEmbedded,
      environmentConfig: environmentConfig || null,
      brandName: environmentConfig?.brandName || null,
      storagePrefix: environmentConfig?.storagePrefix || null,
    };
  }, [AMPLIFY_BRANCH]);
}
